import React, { useCallback, useEffect, useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Interaction from "../../components/WriteProject/Interaction/Interaction";
import { RootState } from "../../reducers";
import { LeaderInter } from "../../reducers/data";
import "./css/index.css";
import { ProjectState } from "../../interface/initialState";
import { ProjectReducer } from "../../interface/ActionReducer";
import UsePostProject from "../../hooks/UsePostProject";
import { PrjtCategory, ProjectDataChange } from "../../lib/lib";
import LookProject from "../../components/LookProject/LookProject";
import { ToastChange } from "../../reducers/config";

type LocationType = {
  state:
    | {
        prjt_id: string;
        prjt_sts_cd: string;
      }
    | undefined;
  pathname: string;
};

function WriteProject() {
  const patch = useDispatch();
  const location = useLocation() as LocationType;
  const path = location.pathname.split("/")[4];
  const leaderInfo = useSelector<RootState, LeaderInter>(
    (state) => state.data.leader
  );
  const [state, dispatch] = useReducer(ProjectReducer, undefined, ProjectState);
  const [isError, setisError] = useState<boolean>(false);
  const [isLook, setIsLook] = useState<boolean>(false);
  const [PostProject, UpdateCommon, ProjectSave] = UsePostProject({
    type: "prjt",
    id: location.state?.prjt_id,
    prjtType: location.state?.prjt_sts_cd,
    dispatch,
    leaderInfo,
  });
  const Valid = useCallback(() => {
    const step = Number(path);
    const {
      title,
      mainimg,
      period: { start, finish },
      leader: { id },
      field: { detail },
    } = state;
    const startTime = new Date(start).getTime();
    const finishTime = new Date(finish).getTime();
    if (step === 1) {
      return title && mainimg && finishTime > startTime && id;
    } else if (step === 3) {
      const deletefilter = detail.filter((item: any) => item.IUD !== "D");
      if (deletefilter.length > 0) {
        if (
          deletefilter.filter((item: any) => item.rcrt_usr_cnt < 1).length < 1
        ) {
          return true;
        } else {
          patch(
            ToastChange({
              active: true,
              content: "모집인원을 1명 이상 입력해주세요",
            })
          );
          return false;
        }
      } else {
        patch(
          ToastChange({
            active: true,
            content: "모집 분야를 추가해주세요",
          })
        );
        return false;
      }
    } else {
      return true;
    }
  }, [state, path]);

  const InsertProject = useCallback(
    (template: string) => {
      PostProject(ProjectDataChange(state, template));
    },
    [state, PostProject]
  );
  const SaveProject = useCallback(
    (template: string | undefined) => {
      ProjectSave(
        ProjectDataChange(state, template ? template : state.template)
      );
    },
    [state, ProjectSave]
  );

  useEffect(() => {
    sessionStorage.setItem("write", JSON.stringify(state));
    return () => {};
  }, [state]);

  return state ? (
    <main className="write-project" id="wirte-project">
      <div
        className="wrapper"
        style={
          path === "6"
            ? {
                paddingTop: "165px",
              }
            : undefined
        }
      >
        <div className="write-header">
          <div className="left">
            <div className="title">신규 프로젝트 업로드</div>
            <div className="step-wrapper">
              {nav_layouts.map(({ title, path }, idx) => {
                return (
                  <div
                    className={path === location.pathname ? "nav-active" : ""}
                    key={idx}
                  >
                    0{idx + 1} {title}
                  </div>
                );
              })}
            </div>
          </div>
          {path !== "6" ? (
            <button
              onClick={() => {
                setIsLook(true);
              }}
            >
              미리보기
            </button>
          ) : undefined}
        </div>
        <Outlet
          context={{
            state,
            dispatch,
            isError,
            Insert: InsertProject,
            UpdateCommon,
            Save: SaveProject,
            setIsLook,
            status:
              location.state && location.state.prjt_sts_cd !== "prjt_sts_tmp"
                ? "fix"
                : "new",
            type: "project",
          }}
        />
        {path !== "6" ? (
          <Interaction
            path={Number(path)}
            type={
              location.state && location.state.prjt_sts_cd !== "prjt_sts_tmp"
                ? "fix"
                : "new"
            }
            setisError={setisError}
            valid={Valid}
            Save={SaveProject}
            data={location.state}
          />
        ) : undefined}
      </div>
      <LookProject
        Data={state}
        type="project"
        categoryContent={
          PrjtCategory[state.category as keyof typeof PrjtCategory]
        }
        price={state.price}
        isLook={isLook}
        Cancel={setIsLook}
      />
    </main>
  ) : (
    <></>
  );
}

export default WriteProject;

const nav_layouts = [
  {
    title: "기본정보",
    path: "/prjt/write/step/1",
  },
  {
    title: "팀플리더 소개",
    path: "/prjt/write/step/2",
  },
  {
    title: "모집분야 및 인원",
    path: "/prjt/write/step/3",
  },
  {
    title: "완주보상",
    path: "/prjt/write/step/4",
  },
  {
    title: "패널티 및 강퇴조건",
    path: "/prjt/write/step/5",
  },
  {
    title: "상세내용",
    path: "/prjt/write/step/6",
  },
];
